'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLinkElementUrl = exports.toggleLinkAttachment = exports.fetchLinkAttachment = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Services


// Actions


// Constants


var _lodash = require('lodash');

var _mediaService = require('../../utils/services/mediaService');

var _mediaService2 = _interopRequireDefault(_mediaService);

var _boardService = require('../../element/board/boardService');

var _elementActions = require('../../element/elementActions');

var _selectionActions = require('../selection/selectionActions');

var _elementAttachmentActions = require('../../element/elementAttachmentActions');

var _imageConstants = require('../../../common/images/imageConstants');

var _aliasConstants = require('../../../common/alias/aliasConstants');

var _richMediaConstants = require('../../../common/links/richMediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchLinkAttachment = exports.fetchLinkAttachment = function fetchLinkAttachment(_ref) {
    var id = _ref.id,
        url = _ref.url;
    return function (dispatch, getState) {
        dispatch((0, _elementAttachmentActions.uploadingElementAttachment)({ id: id }));

        return _mediaService2.default.link.fetchLinkAttachment({ id: id, url: url }).then(function (_ref2) {
            var data = _ref2.data;

            dispatch((0, _elementAttachmentActions.completedUploadingElementAttachment)({ id: id }));

            if (!data.image) return;

            var changes = _extends({}, data, {
                showAttachment: true
            });

            dispatch((0, _elementActions.updateElement)({
                id: id,
                changes: changes
            }));
        });
    };
};

var toggleLinkAttachment = exports.toggleLinkAttachment = function toggleLinkAttachment() {
    return function (dispatch, getState) {
        var state = getState();

        var elementId = state.getIn(['app', 'selection', 'ids']).first();
        var element = state.get('elements').get(elementId);

        var fetching = element.getIn(['attachment', 'fetching']);
        if (fetching) return;

        dispatch((0, _elementActions.updateElement)({
            id: elementId,
            changes: {
                showAttachment: !element.getIn(['content', 'showAttachment'])
            }
        }));
    };
};

var getChangesCaption = function getChangesCaption(data) {
    if (!data.description) return {};

    var showCaption = data.mediaType !== _richMediaConstants.MEDIA_TYPES.VIDEO && data.mediaType !== _richMediaConstants.MEDIA_TYPES.RICH;
    return {
        caption: data.description,
        showCaption: showCaption
    };
};

var prepareChanges = function prepareChanges(data) {
    return _extends({}, (0, _lodash.omit)(data, ['description', 'elementType']), getChangesCaption(data));
};

var linkHasAttachment = function linkHasAttachment(changes) {
    return (0, _lodash.get)(changes, ['link', 'hasAttachment']);
};

var handleLinkTypeResponse = function handleLinkTypeResponse(id, data) {
    return function (dispatch, getState) {
        var changes = prepareChanges(data);

        dispatch((0, _elementActions.updateElement)({
            id: id,
            changes: changes
        }));

        // TODO This seems very round-about, is the experience really worth the extra code?
        if (linkHasAttachment(changes)) {
            dispatch(fetchLinkAttachment({ id: id, url: (0, _lodash.get)(changes, ['link', 'url']) }));
        }
    };
};

var handleImageTypeResponse = function handleImageTypeResponse(id, data) {
    return function (dispatch, getState) {
        var changes = prepareChanges(data);

        dispatch((0, _elementActions.setElementType)({
            id: id,
            elementType: _imageConstants.IMAGE_TYPE
        }));

        dispatch((0, _elementActions.updateElement)({
            id: id,
            changes: changes
        }));
    };
};

var handleAliasTypeResponse = function handleAliasTypeResponse(id, data) {
    return function (dispatch, getState) {
        var changes = prepareChanges(data);

        dispatch((0, _elementActions.setElementType)({
            id: id,
            elementType: _aliasConstants.ALIAS_TYPE
        }));

        dispatch((0, _elementActions.updateElement)({
            id: id,
            changes: changes
        }));

        dispatch((0, _boardService.fetchBoard)({ boardId: data.linkTo }));
    };
};

var setLinkElementUrl = exports.setLinkElementUrl = function setLinkElementUrl(_ref3) {
    var id = _ref3.id,
        url = _ref3.url;
    return function (dispatch, getState) {
        var fetching = getState().getIn(['elements', id, 'attachment', 'fetching']);
        if (fetching) return;

        dispatch((0, _elementAttachmentActions.uploadingElementAttachment)({ id: id }));
        dispatch((0, _selectionActions.finishEditingElement)());

        return _mediaService2.default.link.fetchLink({ id: id, url: url }).then(function (_ref4) {
            var data = _ref4.data;

            if (!data || data.error) throw new Error('no data');
            dispatch((0, _elementAttachmentActions.completedUploadingElementAttachment)({ id: id }));

            switch (data.elementType) {
                case _imageConstants.IMAGE_TYPE:
                    return dispatch(handleImageTypeResponse(id, data));
                case _aliasConstants.ALIAS_TYPE:
                    return dispatch(handleAliasTypeResponse(id, data));
                default:
                    return dispatch(handleLinkTypeResponse(id, data));
            }
        }).catch(function (err) {
            var error = (0, _lodash.get)(err, ['response', 'data', 'error'], err);
            console.error(error);

            dispatch((0, _elementAttachmentActions.completedUploadingElementAttachment)({ id: id }));
            dispatch((0, _elementActions.updateElement)({
                id: id,
                sync: false,
                changes: {
                    temp: { error: error, url: url }
                }
            }));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/linkActions.js
// module id = 740
// module chunks = 0